// crm-web/frontend/src/hooks/useVersionCheck.js
// Chequea la version del servidor y reporta si hay una nueva disponible.
// Complementa al banner global de Dashboard.jsx: corre en cada check de analytics
// (mas frecuente si el auto-refresh esta activo) y sobrevive tabs throttled.

import { useEffect, useRef, useState, useCallback } from 'react'

export default function useVersionCheck(intervalMs = 60000) {
  const [hasUpdate, setHasUpdate] = useState(false)
  const initialVersion = useRef(null)

  const check = useCallback(async () => {
    try {
      const res = await fetch('/api/crm-web/version', { cache: 'no-store' })
      if (!res.ok) return
      const data = await res.json()
      if (!initialVersion.current) {
        initialVersion.current = data.v
      } else if (data.v !== initialVersion.current) {
        setHasUpdate(true)
      }
    } catch {
      // silent (network transient)
    }
  }, [])

  useEffect(() => {
    check()
    const id = setInterval(check, intervalMs)
    return () => clearInterval(id)
  }, [check, intervalMs])

  const reload = useCallback(() => window.location.reload(), [])

  return { hasUpdate, reload, check }
}
